import { Path } from '@/main/router/routerPath';

import { Fakturace } from './fakturace';

export const router = new Path('uctenky').addChildren([
	Fakturace.router,
]);
